<ion-accordion-group expand="inset">
  <ion-accordion value="esupport">
    <ion-item slot="header" color="lime">
      <ion-label><i class="far fa-object-group"></i> &nbsp; NAAC Metrics</ion-label>
    </ion-item>
    <div class="ion-padding" slot="content">
      <!-- Content Start -->
      <ion-segment (ionChange)="metricSegmentChanged($event)" value="SUGGESTED">
        <ion-segment-button value="SUGGESTED">
          <ion-label>SUGGESTED</ion-label>
        </ion-segment-button>
        <ion-segment-button value="OTHER">
          <ion-label>OTHER</ion-label>
          <div *ngIf="showOther">
          </div>
        </ion-segment-button>
      </ion-segment>
      <div *ngIf="showSuggested" class="p-2">
        <div class="card-body" *ngIf="!(showQnMSuggested || showQlMSuggested)">No applicable metric available</div>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnMSuggested">
          <li class="list-inline-item"><i class="fab fa-dot"></i> &nbsp;Quantitative Metrics &nbsp;</li>
        </ul>
        <ul class="list-inline mt-1 mb-1"
          *ngIf="showQnMSuggested && eSupportMapping.UG.length != 0 && form.collegeType=='UG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;UG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.UG; let i = index">
            <span (click)="openEsupport(matricId, 'UG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1"
          *ngIf="showQnMSuggested && eSupportMapping.PG.length != 0 && form.collegeType=='PG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;PG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.PG; let i = index">
            <span (click)="openEsupport(matricId, 'PG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1"
          *ngIf="showQnMSuggested && eSupportMapping.AU.length != 0 && form.collegeType=='AU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.AU; let i = index">
            <span (click)="openEsupport(matricId, 'AU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1"
          *ngIf="showQnMSuggested && eSupportMapping.CU.length != 0 && form.collegeType=='CU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;CU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.CU; let i = index">
            <span (click)="openEsupport(matricId, 'CU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1"
          *ngIf="showQnMSuggested && eSupportMapping.AC.length != 0 && form.collegeType=='AC'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AC &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.AC; let i = index">
            <span (click)="openEsupport(matricId, 'AC')">{{matricId}}</span>
          </li>
        </ul>

        <ul class="list-inline mt-1 mb-1 separator" *ngIf="showQnMSuggested && showQlMSuggested">
          <li class="list-inline-item ">&nbsp;</li>
        </ul>

        <ul class="list-inline mt-1 mb-1" *ngIf="showQlMSuggested">
          <li class="list-inline-item"><i class="fab fa-dot"></i> &nbsp;Qualitative Metrics &nbsp;</li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlMSuggested && eSupportMapping.qlm.UG && form.collegeType=='UG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;UG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.UG; let i = index">
            <span (click)="openQlMEsupport(matricId, 'UG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlMSuggested && eSupportMapping.qlm.PG && form.collegeType=='PG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;PG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.PG; let i = index">
            <span (click)="openQlMEsupport(matricId, 'PG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlMSuggested && eSupportMapping.qlm.AU && form.collegeType=='AU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.AU; let i = index">
            <span (click)="openQlMEsupport(matricId, 'AU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlMSuggested && eSupportMapping.qlm.CU && form.collegeType=='CU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;CU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.CU; let i = index">
            <span (click)="openQlMEsupport(matricId, 'CU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlMSuggested && eSupportMapping.qlm.AC && form.collegeType=='AC'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AC &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.AC; let i = index">
            <span (click)="openQlMEsupport(matricId, 'AC')">{{matricId}}</span>
          </li>
        </ul>
      </div>
      <div *ngIf="showOther" class="p-2">
        <div class="card-body" *ngIf="!(showQnM || showQlM)">No applicable metric available</div>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnM">
          <li class="list-inline-item"><i class="fab fa-dot"></i> &nbsp;Quantitative Metrics &nbsp;</li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnM && eSupportMapping.UG.length != 0 && form.collegeType !='UG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;UG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.UG; let i = index">
            <span (click)="openEsupport(matricId, 'UG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnM && eSupportMapping.PG.length != 0 && form.collegeType !='PG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;PG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.PG; let i = index">
            <span (click)="openEsupport(matricId, 'PG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnM && eSupportMapping.AU.length != 0 && form.collegeType !='AU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.AU; let i = index">
            <span (click)="openEsupport(matricId, 'AU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnM && eSupportMapping.CU.length != 0 && form.collegeType !='CU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;CU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.CU; let i = index">
            <span (click)="openEsupport(matricId, 'CU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnM && eSupportMapping.AC.length != 0 && form.collegeType !='AC'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AC &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.AC; let i = index">
            <span (click)="openEsupport(matricId, 'AC')">{{matricId}}</span>
          </li>
        </ul>

        <ul *ngIf="showQnM && showQlM" class="list-inline mt-1 mb-1 separator">
          <li class="list-inline-item ">&nbsp;</li>
        </ul>

        <ul class="list-inline mt-1 mb-1" *ngIf="showQlM">
          <li class="list-inline-item"><i class="fab fa-dot"></i> &nbsp;Qualitative Metrics &nbsp;</li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlM && eSupportMapping.qlm.UG && form.collegeType !='UG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;UG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.UG; let i = index">
            <span (click)="openQlMEsupport(matricId, 'UG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlM && eSupportMapping.qlm.PG && form.collegeType !='PG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;PG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.PG; let i = index">
            <span (click)="openQlMEsupport(matricId, 'PG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlM && eSupportMapping.qlm.AU && form.collegeType !='AU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.AU; let i = index">
            <span (click)="openQlMEsupport(matricId, 'AU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlM && eSupportMapping.qlm.CU && form.collegeType !='CU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;CU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.CU; let i = index">
            <span (click)="openQlMEsupport(matricId, 'CU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlM && eSupportMapping.qlm.AC && form.collegeType !='AC'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AC &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.AC; let i = index">
            <span (click)="openQlMEsupport(matricId, 'AC')">{{matricId}}</span>
          </li>
        </ul>
      </div>
      <div class="text-right p-2">
        <button
          *ngIf="((isIQACADMIN && isFROMIQACDASHBOARD)||(isFROM_CRITERIA_DASHBOARD && isCRITERIA_COORDINATORS)) && formId"
          type="button" class="btn btn-sm btn-info mb-1 mt-2" (click)="openNaacMetricPage()">
          Apply NAAC metrics&nbsp; <i class="fas fa-arrow-alt-circle-right"></i>
        </button>
      </div>
      <div id="selected-numbers">
        <div class="card">
          <div class="card-header" style="font-size: 15px;">
            <strong> APPLIED METRICS </strong>
          </div>
          <div class="card-body row">
            <span class="badge rounded-pill bg-success text-dark"
              style="width: 77px;margin: 16px;"
             *ngFor="let number of nackmetricNumberList">
              {{number}}
            </span>
            <span class="badge rounded-pill bg-warning text-dark"
              style="width: 77px;margin: 14px;"
              *ngIf="!nackmetricNumberList || nackmetricNumberList.length < 1">
              No metric applied
            </span>
          </div>
        </div>
      </div>
      <!-- Content End -->
    </div>
  </ion-accordion>
</ion-accordion-group>